import React, { useEffect, useState } from "react";
import { closeModal, SweetAlertShow, LoadingDiv } from "../../master/Master";
import Header from "../../master/SideBar";
import Nav from "../../master/NavBar";
import usePrivateLink from "../../config/usePrivateLink";
import Swal from "sweetalert2";
import {
  sessionAdd,
  sessionDelete,
  sessionList,
  sessionStatusChange,
  sessionUpdate,
} from "../../../api/Sessions";
import { formatToDate } from "../../master/FormatToDateTime";
import AcademicPortalLayout from "../AcademicPortalLayout";

export default function Sessions() {
  const hasAccess = usePrivateLink();
  const [data, setData] = useState([]);
  const [modelData, setModelData] = useState("");
  const [loading, setLoading] = useState(false);

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await sessionList();
      if (response.data.status) {
        setData(response.data.data);
        localStorage.setItem("sessions", JSON.stringify(response.data.data));
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  const createSession = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await sessionAdd(formData);
      if (response?.data?.status) {
        e.target.reset();
        closeModal("addSession");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSession();
    }
  };

  const deleteSession = async (id) => {
    setLoading(true);
    try {
      const response = await sessionDelete(id);
      if (response?.data?.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSession();
    }
  };

  const updateSessionStatus = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await sessionStatusChange(formData);
      if (response?.data?.status) {
        e.target.reset();
        closeModal("statusChange");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSession();
    }
  };

  const updateSession = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData(e.target);
      const response = await sessionUpdate(formData);
      if (response?.data?.status) {
        e.target.reset();
        closeModal("updateSession");
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message,
      );
    } finally {
      setLoading(false);
      getSession();
    }
  };

  useEffect(() => {
    getSession();
  }, []);

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <AcademicPortalLayout />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="row g-2">
                          <div className="col-sm-6">
                            <h4 className="text-primary m-0">Sessions</h4>
                          </div>
                          <div className="col-sm-6 text-end">
                            {hasAccess("/sessions/add") && (
                              <button
                                className="btn btn-outline-primary btn-sm"
                                data-bs-toggle="modal"
                                data-bs-target="#addSession"
                              >
                                <i className="ri-add-circle-line me-2"></i>
                                Add Session
                              </button>
                            )}
                          </div>
                          <div className="col-12">
                            <div className="table-responsive">
                              <table className="table table-hover">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Session Name</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Status</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {data?.map((item, i) => (
                                    <tr key={item.id}>
                                      <td>{i + 1}</td>
                                      <td>{item.session}</td>
                                      <td>{formatToDate(item.start_date)}</td>
                                      <td>{formatToDate(item.end_date)}</td>
                                      <td>
                                        {hasAccess("/session/status") && (
                                        <button
                                          onClick={() => setModelData(item)}
                                          className={`btn btn-sm px-2 py-1 rounded-3 ${
                                            item?.status === "0"
                                              ? "btn-label-info"
                                              : item?.status === "1"
                                                ? "btn-label-success"
                                                : "btn-label-secondary"
                                          }`}
                                          data-bs-toggle="modal"
                                          data-bs-target="#statusChange"
                                        >
                                          {item?.status === "0"
                                            ? "Upcoming"
                                            : item?.status === "1"
                                              ? "Active"
                                              : "Complete"}
                                        </button>
                                        )}
                                      </td>
                                      <td>
                                        {hasAccess("/session/update") && (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-info mx-1"
                                            onClick={() => setModelData(item)}
                                            data-bs-toggle="modal"
                                            data-bs-target="#updateSession"
                                          >
                                            <i className="ri-ball-pen-line" />
                                          </button>
                                        )}
                                        {hasAccess("/session/delete") && (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-danger mx-1"
                                            onClick={() => {
                                              Swal.fire({
                                                title: "Are you sure?",
                                                text: "This action will permanently delete!",
                                                icon: "warning",
                                                showCancelButton: true,
                                                confirmButtonColor: "#d33",
                                                cancelButtonColor: "#6c757d",
                                                confirmButtonText:
                                                  "Yes, delete it!",
                                                cancelButtonText: "Cancel",
                                              }).then((result) => {
                                                if (result.isConfirmed) {
                                                  deleteSession(item.id);
                                                }
                                              });
                                            }}
                                          >
                                            <i className="ri-delete-bin-line" />
                                          </button>
                                        )}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="addSession"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={createSession}>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Add New Session
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="form-floating form-floating-outline mb-6">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    name="session"
                    id="session"
                    required
                  />
                  <label htmlFor="session">Session Name</label>
                </div>

                <div className="form-floating form-floating-outline mb-6">
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    required
                  />
                  <label>Start Date</label>
                </div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="updateSession"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={updateSession}>
              <div className="modal-header bg-label-primary py-3">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Update Session
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <div className="form-floating form-floating-outline mb-6">
                  <input
                    type="hidden"
                    className="form-control"
                    name="id"
                    id="id"
                    value={modelData?.id}
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter Name"
                    name="session"
                    id="session"
                    required
                    defaultValue={modelData?.session}
                  />
                  <label htmlFor="session">Session Name</label>
                </div>

                <div className="form-floating form-floating-outline mb-6">
                  <input
                    type="date"
                    className="form-control"
                    name="start_date"
                    required
                    defaultValue={modelData?.start_date}
                  />
                  <label>Start Date</label>
                </div>
                <div className="form-floating form-floating-outline mb-6">
                  <input
                    type="date"
                    className="form-control"
                    name="end_date"
                    required
                    defaultValue={modelData?.end_date}
                  />
                  <label>End Date</label>
                </div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>

                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Submit"
                  )}
                  {loading ? " Submitting..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="statusChange"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <form onSubmit={updateSessionStatus}>
              <div className="modal-header bg-label-primary py-3">
                <h3 className="modal-title fs-5  " id="exampleModalLabel">
                  Change Status
                </h3>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input type="hidden" value={modelData?.id} name="id" required />
                <div className=" form-floating form-floating-outline mb-b">
                  <select name="status" className="form-control">
                    <option
                      selected={modelData?.status === "0" && true}
                      value="0"
                    >
                      Upcoming
                    </option>
                    <option
                      selected={modelData?.status === "1" && true}
                      value="1"
                    >
                      Active
                    </option>
                    <option
                      selected={modelData?.status === "2" && true}
                      value="2"
                    >
                      Complete
                    </option>
                  </select>
                  <label>Select Status</label>
                </div>
                <div className="d-flex justify-content-end mt-5 "></div>
              </div>
              <div className="modal-footer  bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-danger btn-sm"
                  data-bs-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-5"
                  disabled={loading}
                >
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Update"
                  )}
                  {loading ? " Updating..." : ""}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
